class MobileNav {
  constructor(element, options) {
    this.element = element;
    this.options = options;

    this.showButton = document.querySelector(this.options.selectorShow);
    this.closeButton = element.querySelector(this.options.selectorClose);

    if (this.showButton) {
      this.showButton.addEventListener('click', () => {
        this.show();
      });
    }

    this._hookCloseActions();
  }

  _hookCloseActions() {
    this.closeButton.addEventListener('click', () => {
      this.hide();
    });

    document.body.addEventListener('keydown', evt => {
      if (evt.which === 27) {
        evt.stopPropagation();
        this.hide();
      }
    });
  }

  show() {
    this.element.classList.toggle(this.options.classVisible, true);
    document.body.classList.toggle(this.options.bodyClassVisible, true);
  }

  hide() {
    this.element.classList.toggle(this.options.classVisible, false);
    document.body.classList.toggle(this.options.bodyClassVisible, false);
  }

  static create(element) {
    new this(element, this.options);
  }

  static init() {
    const element = document.querySelector('[data-mobile-nav]');
    this.create(element);
  }

  static options = {
    selectorInit: '[data-mobile-nav]',
    selectorShow: '[data-mobile-nav-show]',
    selectorClose: '[data-mobile-nav-close]',
    classVisible: 'is-visible',
    bodyClassVisible: 'mobile-nav-visible',
  };
}

export default MobileNav;
